var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "component" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "main-content" },
      [
        _c("portrait-labels", {
          attrs: { labelList: _vm.componentData.skillOverview }
        }),
        _vm._v(" "),
        _vm.componentData.majorSkill != null &&
        _vm.componentData.majorSkill.length > 0
          ? _c("div", { staticClass: "sub" }, [
              _c("div", { staticClass: "sub-title" }, [
                _vm._v("\n                专业技能明细\n            ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sub-content" },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { "{width": "100%}" },
                      attrs: {
                        data: _vm.componentData.majorSkill,
                        "header-cell-style": {
                          background: "#F2F2F2",
                          height: "32px",
                          "font-size": "12px",
                          color: "#212121"
                        },
                        "cell-style": { "font-size": "12px", color: "#212121" }
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "skillName",
                          label: "技能名称",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "skillLevel",
                          label: "掌握程度",
                          width: "180"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "skillPrj",
                          label: "项目",
                          formatter: _vm.fileData
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.componentData.languageSkill != null &&
        _vm.componentData.languageSkill.length > 0
          ? _c(
              "div",
              { staticClass: "sub-row" },
              [
                _c("div", { staticClass: "sub-title" }, [
                  _vm._v("\n                语言技能\n            ")
                ]),
                _vm._v(" "),
                _c("portrait-labels", {
                  attrs: { labelList: _vm.componentData.languageSkill }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.componentData.certificate != null &&
        _vm.componentData.certificate.length > 0
          ? _c(
              "div",
              { staticClass: "sub-row" },
              [
                _c("div", { staticClass: "sub-title" }, [
                  _vm._v("\n                证书\n            ")
                ]),
                _vm._v(" "),
                _c("portrait-labels", {
                  attrs: { labelList: _vm.componentData.certificate }
                })
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "main-title" }, [
      _c("div", { staticClass: "square" }),
      _vm._v(" "),
      _c("div", { staticClass: "title-content" }, [_vm._v("技能概览")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }